import { makeStyles } from "@fluentui/react-components";

export const useAccountMenuStyles = makeStyles({
  settingsContainer: {
    position: "absolute",
    bottom: "clamp(10px, 20px, 30px)",
    right: "clamp(10px, 20px, 30px)",
  },
});
